import { ModuleSizes } from '../../../../../types/Survey/Analysis/Concept'
import { ResultPropsHybrid } from '../../../../../types/Survey/Analysis/FactorValues'

const getHybridTemplate = (): ResultPropsHybrid => {
  return Object.keys(ModuleSizes).reduce((acc, key) => {
    const moduleSize = ModuleSizes[key]
    acc[moduleSize] = {
      practicalSpaceAmount: 0,
      practicalQM: 0,
      arbeitsplatzAmount: 0,
    }
    return acc
  }, {} as ResultPropsHybrid)
}

export default getHybridTemplate
